module.exports = __webpack_public_path__ + "static/gain-6e04e85061e7bf59730c7ada7637457c.png";